import {
  GET_TIMEINFO,
  INSERT_TIMEINFO,
  UPDATE_TIMEINFO,
  DELETE_TIMEINFO,
  FULFILLED,
  REJECTED,
  PENDING
} from "../utils/types";
const initialState = {
  data: {},
  getError: false,
  updateError: false,
  deleteError: false,
  insertError: false,
  getLoading: false,
  updateLoading: false,
  deleteLoading: false,
  insertLoading: false
};

export default function timeInfoReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    // GET
    case `${GET_TIMEINFO + PENDING}`:
      return { ...state, getError: false, getLoading: true };
    case `${GET_TIMEINFO + FULFILLED}`:
      return { ...state, data: payload, getError: false, getLoading: false };
    case `${GET_TIMEINFO + REJECTED}`:
      return { ...state, getError: true, getLoading: false, data: {} };
    // UPDATE
    case `${UPDATE_TIMEINFO + PENDING}`:
      return { ...state, updateError: false, updateLoading: true };
    case `${UPDATE_TIMEINFO + FULFILLED}`:
      return {
        ...state,
        data: payload,
        updateError: false,
        updateLoading: false
      };
    case `${UPDATE_TIMEINFO + REJECTED}`:
      return { ...state, updateError: true, updateLoading: false };
    // DELETE
    case `${DELETE_TIMEINFO + PENDING}`:
      return { ...state, deleteError: false, deleteLoading: true };
    case `${DELETE_TIMEINFO + FULFILLED}`:
      return {
        ...state,
        data: payload,
        deleteError: false,
        deleteLoading: false
      };
    case `${DELETE_TIMEINFO + REJECTED}`:
      return { ...state, deleteError: true, deleteLoading: false};
    // INSERT
    case `${INSERT_TIMEINFO + PENDING}`:
      return { ...state, insertError: false, insertLoading: true };
    case `${INSERT_TIMEINFO + FULFILLED}`:
      return {
        ...state,
        data: payload,
        insertError: false,
        insertLoading: false
      };
    case `${INSERT_TIMEINFO + REJECTED}`:
      return { ...state, insertError: true, insertLoading: false};
    default:
      return state;
  }
}
